__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "dasher";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(2633))), 1);
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(76892))), 1);
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(35119))), 1);
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(11304))), 1);
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(39869))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(55979))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(44031))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(79192))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(78146))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(95038))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(62291))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(78688))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(68032))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(92826))), 1);
			initExternal(51297);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};